import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  HStack,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  OrderedList,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { MdCheckCircle, MdDangerous } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddAnswerData } from "redux/slices/addAnswerSlice";
import { getAddQuestionData } from "redux/slices/AddQuestionSlice";
import { getAddTestData, setTests } from "redux/slices/AddTestSlice";
import AddTest from "./AddTest";

export default function TestModal({ formationId }: { formationId: number }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [id, setId] = useState(0);
  const dispatch = useAppDispatch();
  const { title, description } = useAppSelector(getAddTestData);
  const { questions } = useAppSelector(getAddQuestionData);
  const { answers } = useAppSelector(getAddAnswerData);
  const tests = useAppSelector(getAddTestData).tests;
  const addTestSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      setTests([
        ...tests,
        {
          addedOn: new Date(),
          lastModifiedOn: null,
          description,
          title,
          id: id,
          formationId,
        },
      ])
    );
  };
  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Test
      </Button>

      <Modal
        closeOnOverlayClick={false}
        size="3xl"
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Ajouter un test</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {tests.length > 0 && (
              <VStack spacing={2}>
                <HStack spacing={2}>
                  <Text>Titre</Text>
                  <Text>{tests[0].title}</Text>
                </HStack>
                <HStack spacing={2}>
                  <Text>Description</Text>
                  <Text>{tests[0].description}</Text>
                </HStack>
                <VStack spacing={5}>
                  <Text>Questions</Text>
                  <OrderedList>
                    {questions.map((question, index) => (
                      <VStack>
                        <ListItem>{question.content}</ListItem>
                        <Text>Réponses</Text>
                        <List spacing={3}>
                          {answers
                            .filter(
                              (answer) => answer.questionId === question.id
                            )
                            .map((answer, index) => (
                              <ListItem>
                                <ListIcon
                                  as={
                                    answer.isCorrect === true
                                      ? MdCheckCircle
                                      : MdDangerous
                                  }
                                  color={
                                    answer.isCorrect === true
                                      ? "green.500"
                                      : "red.400"
                                  }
                                />
                                {answer.content}
                              </ListItem>
                            ))}
                        </List>
                      </VStack>
                    ))}
                  </OrderedList>
                </VStack>
              </VStack>
            )}

            <AddTest
              testId={id}
              setTestId={setId}
              submitHandler={addTestSubmitHandler}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="brand" mr={3}>
              Enregistrer
            </Button>
            <Button onClick={onClose}>Annuler</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
